import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _styled from "styled-components";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useMemo, useCallback, useEffect, useRef, useState } from 'react';
import usePlacesAutocomplete from 'use-places-autocomplete';
import { ExclamationCircleIcon } from '@heroicons/react/24/solid';
import { Controller } from 'react-hook-form';
import { useOnClickOutside } from 'usehooks-ts';
import { useFloating, offset, flip, autoUpdate } from '@floating-ui/react';
import { MarkerPinIcon, useGmapsScript } from '@restworld/utils-common';
import { FormLabelWrapper, TextInput, Title, HelperTextRElement } from '../..'; // export const locationInputValueAtom = atom<string>('');

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var GoogleAutoCompleteInput = function GoogleAutoCompleteInput(_ref) {
  var mainLabel = _ref.mainLabel,
      formId = _ref.formId,
      placeholder = _ref.placeholder,
      disabled = _ref.disabled,
      placesFilterTypes = _ref.placesFilterTypes,
      _onSuggestionSelect = _ref.onSuggestionSelect,
      title = _ref.title,
      subTitle = _ref.subTitle,
      required = _ref.required,
      testId = _ref.testId,
      formValue = _ref.formValue,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
      control = _ref.control,
      helperText = _ref.helperText,
      dropdownTestId = _ref.dropdownTestId,
      inputProps = _ref.inputProps,
      dropdownItemProps = _ref.dropdownItemProps;
  var dropdownRef = useRef(null);

  var _useState = useState(''),
      locationInputValue = _useState[0],
      onLocationInputChange = _useState[1];

  var _useState2 = useState(false),
      cardOverlay = _useState2[0],
      setCardOverlay = _useState2[1];

  var scriptReady = useGmapsScript({
    libraries: "places&types=".concat(placesFilterTypes)
  });

  var _useLocationSearch = useLocationSearch(_objectSpread({
    setCardOverlay: setCardOverlay,
    placesFilterTypes: placesFilterTypes,
    onSuggestionSelect: function onSuggestionSelect(placesData) {
      _onSuggestionSelect === null || _onSuggestionSelect === void 0 ? void 0 : _onSuggestionSelect(placesData);
    },
    formId: formId,
    scriptReady: scriptReady,
    locationInputValue: locationInputValue,
    onLocationInputChange: onLocationInputChange
  }, dropdownItemProps)),
      renderSuggestions = _useLocationSearch.renderSuggestions;

  useOnClickOutside(dropdownRef, function () {
    setCardOverlay(false);
  });
  var suggestionList = useMemo(function () {
    return locationInputValue && scriptReady ? /*#__PURE__*/_jsx(_StyledUl, {
      "data-cy": "address-suggestion-dropdown",
      children: renderSuggestions()
    }) : null;
  }, [locationInputValue, renderSuggestions, scriptReady]);
  var inputRef = useRef(null);
  var DROPDOWN_OFFSET = 4;

  var _useFloating = useFloating({
    placement: 'bottom-start',
    open: cardOverlay,
    onOpenChange: setCardOverlay,
    middleware: [offset(DROPDOWN_OFFSET), flip({
      padding: 5
    })],
    whileElementsMounted: autoUpdate,
    transform: true
  }),
      refs = _useFloating.refs,
      floatingStyles = _useFloating.floatingStyles;

  useEffect(function () {
    if (inputRef.current && autoFocus) inputRef.current.focus();
  }, [autoFocus, inputRef]);
  useEffect(function () {
    if (formValue) onLocationInputChange(formValue);
  }, [formValue, onLocationInputChange]);
  var inputTextEl = useMemo(function () {
    return /*#__PURE__*/_jsx("div", {
      ref: refs.setReference,
      className: "reference",
      children: /*#__PURE__*/_jsx(TextInput, _objectSpread({}, _objectSpread(_objectSpread(_objectSpread({
        type: 'text',
        placeholder: placeholder,
        id: formId,
        borderless: false,
        onChange: function onChange(value) {
          setCardOverlay(true);
          onLocationInputChange(value);
        },
        autoFocus: false,
        wrapperStyle: {
          "width": "100%"
        },
        bordercolor: 'primary',
        disabled: disabled,
        value: locationInputValue
      }, helperText ? {
        helperText: /*#__PURE__*/_jsx(HelperTextRElement, {
          helperText: helperText
        })
      } : {}), inputProps), {}, {
        ref: inputRef,
        testId: testId || 'google-auto-complete-input'
      })))
    });
  }, [disabled, formId, helperText, inputProps, locationInputValue, onLocationInputChange, placeholder, refs.setReference, testId]);
  var dropdownEl = useMemo(function () {
    return cardOverlay && suggestionList ? /*#__PURE__*/_jsx("div", {
      ref: dropdownRef,
      "data-cy": dropdownTestId,
      children: /*#__PURE__*/_jsx(_StyledDiv, {
        ref: refs.setFloating,
        style: floatingStyles,
        children: /*#__PURE__*/_jsxs(_StyledDiv2, {
          id: "suggestion-4",
          children: [title && /*#__PURE__*/_jsxs(_StyledDiv3, {
            onClick: function onClick() {
              setCardOverlay(false);
            },
            children: [/*#__PURE__*/_jsx(Title, {
              content: title,
              fontSize: "small",
              fontWeight: "semibold",
              twStyle: {
                "lineHeight": "19.5px"
              },
              textColor: "bold-purple"
            }), /*#__PURE__*/_jsx(Title, {
              content: subTitle,
              fontSize: "small",
              fontWeight: "normal",
              twStyle: {
                "lineHeight": "19.5px"
              },
              textColor: "gray-500"
            })]
          }), suggestionList]
        })
      })
    }) : null;
  }, [cardOverlay, dropdownTestId, floatingStyles, refs.setFloating, subTitle, suggestionList, title]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(FormLabelWrapper, {
      isFullWidth: true,
      id: formId,
      label: mainLabel,
      children: control ? /*#__PURE__*/_jsx(Controller, {
        name: formId,
        control: control,
        rules: {
          required: required
        },
        render: function render() {
          return inputTextEl;
        }
      }) : inputTextEl
    }), dropdownEl]
  });
};

var useLocationSearch = function useLocationSearch(_ref2) {
  var setCardOverlay = _ref2.setCardOverlay,
      placesFilterTypes = _ref2.placesFilterTypes,
      onSuggestionSelect = _ref2.onSuggestionSelect,
      scriptReady = _ref2.scriptReady,
      locationInputValue = _ref2.locationInputValue,
      onLocationInputChange = _ref2.onLocationInputChange,
      suffixIcon = _ref2.suffixIcon;

  var _useState3 = useState(null),
      sessionToken = _useState3[0],
      setSessionToken = _useState3[1];

  useEffect(function () {
    var _window, _window$google, _window$google$maps;

    if (!scriptReady || false) return;
    var googleMaps = (_window = window) === null || _window === void 0 ? void 0 : (_window$google = _window.google) === null || _window$google === void 0 ? void 0 : (_window$google$maps = _window$google.maps) === null || _window$google$maps === void 0 ? void 0 : _window$google$maps.places;

    if (googleMaps !== null && googleMaps !== void 0 && googleMaps.AutocompleteSessionToken) {
      setSessionToken(new googleMaps.AutocompleteSessionToken());
    }
  }, [scriptReady]);

  var getSessionToken = function getSessionToken() {
    return sessionToken;
  };

  var _usePlacesAutocomplet = usePlacesAutocomplete({
    initOnMount: false,
    debounce: 300,
    requestOptions: _objectSpread(_objectSpread({}, placesFilterTypes ? {
      types: placesFilterTypes
    } : {}), {}, {
      sessionToken: getSessionToken()
    })
  }),
      ready = _usePlacesAutocomplet.ready,
      _usePlacesAutocomplet2 = _usePlacesAutocomplet.suggestions,
      status = _usePlacesAutocomplet2.status,
      data = _usePlacesAutocomplet2.data,
      setValue = _usePlacesAutocomplet.setValue,
      init = _usePlacesAutocomplet.init;

  var renderSuggestions = useCallback(function () {
    return status === 'OK' ? data.map(function (suggestion, index) {
      var place_id = suggestion.place_id,
          _suggestion$structure = suggestion.structured_formatting,
          main_text = _suggestion$structure.main_text,
          secondary_text = _suggestion$structure.secondary_text;
      return /*#__PURE__*/_jsx(_StyledLi, {
        "data-cy": "address-suggestion-".concat(index),
        onClick: function onClick() {
          setCardOverlay(false);
          onLocationInputChange("".concat(main_text, " ").concat(secondary_text || ''));
          onSuggestionSelect(suggestion);
        },
        children: /*#__PURE__*/_jsxs(_StyledDiv4, {
          "aria-label": "restaurant-places",
          children: [/*#__PURE__*/_jsxs(_StyledDiv5, {
            children: [/*#__PURE__*/_jsx(_StyledMarkerPinIcon, {}), /*#__PURE__*/_jsxs(_StyledDiv6, {
              children: [/*#__PURE__*/_jsx(Title, {
                content: main_text,
                fontWeight: "normal",
                fontSize: "small",
                twStyle: {
                  "lineHeight": "1.313rem"
                }
              }), main_text && secondary_text && /*#__PURE__*/_jsx(Title, {
                content: "Via ".concat(secondary_text),
                fontWeight: "normal",
                fontSize: "small",
                twStyle: {
                  "lineHeight": "1.313rem"
                }
              })]
            })]
          }), suffixIcon]
        })
      }, place_id);
    }) : status === 'ZERO_RESULTS' ? /*#__PURE__*/_jsxs(_StyledLi2, {
      children: [/*#__PURE__*/_jsx(ExclamationCircleIcon, {
        className: "w-5 h-5"
      }), " ", /*#__PURE__*/_jsx("em", {
        children: "Nessun risultato trovato"
      })]
    }) : /*#__PURE__*/_jsx("li", {
      children: /*#__PURE__*/_jsx("em", {
        children: "caricamento..."
      })
    });
  }, [data, onLocationInputChange, onSuggestionSelect, setCardOverlay, status, suffixIcon]);
  useEffect(function () {
    if (locationInputValue) init();
    setValue(locationInputValue);
  }, [init, locationInputValue, setValue]);
  return {
    ready: ready,
    renderSuggestions: renderSuggestions,
    status: status
  };
};

export default GoogleAutoCompleteInput;

var _StyledUl = /*#__PURE__*/_styled("ul").withConfig({
  displayName: "google-auto-complete-input___StyledUl",
  componentId: "sc-3y4wmj-0"
})({
  "display": "flex",
  "maxHeight": "18rem",
  "minHeight": "14rem",
  "flexDirection": "column",
  "gap": "0.75rem",
  "overflowY": "auto",
  "padding": "1rem"
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "google-auto-complete-input___StyledDiv",
  componentId: "sc-3y4wmj-1"
})({
  "position": "absolute",
  "left": "0px",
  "zIndex": "10",
  "width": "100%",
  "maxWidth": "32rem",
  "borderRadius": "0.375rem",
  "borderWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(222 222 225 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "--tw-shadow": "0px 4px 16px 0px rgba(0, 0, 26, 0.50)",
  "--tw-shadow-colored": "0px 4px 16px 0px var(--tw-shadow-color)",
  "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "google-auto-complete-input___StyledDiv2",
  componentId: "sc-3y4wmj-2"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.25rem"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "google-auto-complete-input___StyledDiv3",
  componentId: "sc-3y4wmj-3"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.25rem",
  "borderBottomWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(229 231 235 / var(--tw-border-opacity))",
  "padding": "1rem"
});

var _StyledLi = /*#__PURE__*/_styled("li").withConfig({
  displayName: "google-auto-complete-input___StyledLi",
  componentId: "sc-3y4wmj-4"
})({
  "display": "flex",
  "cursor": "pointer",
  "alignItems": "center",
  "justifyContent": "space-between"
});

var _StyledDiv4 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "google-auto-complete-input___StyledDiv4",
  componentId: "sc-3y4wmj-5"
})({
  "display": "flex",
  "width": "100%",
  "alignItems": "center",
  "justifyContent": "space-between",
  "gap": "0.5rem",
  "paddingTop": "0.625rem",
  "paddingBottom": "0.625rem"
});

var _StyledDiv5 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "google-auto-complete-input___StyledDiv5",
  componentId: "sc-3y4wmj-6"
})({
  "display": "flex",
  "flexDirection": "row",
  "gap": "0.5rem"
});

var _StyledMarkerPinIcon = /*#__PURE__*/_styled(MarkerPinIcon).withConfig({
  displayName: "google-auto-complete-input___StyledMarkerPinIcon",
  componentId: "sc-3y4wmj-7"
})({
  "height": "18px",
  "width": "18px",
  "--tw-text-opacity": "1",
  "color": "rgb(107 114 128 / var(--tw-text-opacity))"
});

var _StyledDiv6 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "google-auto-complete-input___StyledDiv6",
  componentId: "sc-3y4wmj-8"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "flexWrap": "wrap",
  "gap": "0.25rem",
  "textAlign": "left"
});

var _StyledLi2 = /*#__PURE__*/_styled("li").withConfig({
  displayName: "google-auto-complete-input___StyledLi2",
  componentId: "sc-3y4wmj-9"
})({
  "display": "flex",
  "alignItems": "center",
  "gap": "0.25rem",
  "--tw-text-opacity": "1",
  "color": "rgb(28 19 39 / var(--tw-text-opacity))"
});